// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/rollapp/state_info.proto (package dymensionxyz.dymension.rollapp, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { Status } from "./common/status_pb.js";
import { BlockDescriptors } from "./block_descriptor_pb.js";

/**
 * StateInfoIndex is the data used for indexing and retrieving a StateInfo
 * it updated and saved with every UpdateState in StateInfo.
 * We use the this structure also for:
 * 1. LatestStateInfoIndex which defines the rollapps' current (latest) index of the last UpdateState
 * 2. LatestFinalizedStateIndex which defines the rollapps' current (latest) index of the latest StateInfo that was finalized
 *
 * @generated from message dymensionxyz.dymension.rollapp.StateInfoIndex
 */
export class StateInfoIndex extends Message<StateInfoIndex> {
  /**
   * rollappId is the rollapp that the sequencer belongs to and asking to update
   * it used to identify the what rollapp a StateInfo belongs
   * The rollappId follows the same standard as cosmos chain_id
   *
   * @generated from field: string rollappId = 1;
   */
  rollappId = "";

  /**
   * index is a sequential increasing number, updating on each
   * state update used for indexing to a specific state info, the first index is 1
   *
   * @generated from field: uint64 index = 2;
   */
  index = protoInt64.zero;

  constructor(data?: PartialMessage<StateInfoIndex>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.StateInfoIndex";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rollappId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StateInfoIndex {
    return new StateInfoIndex().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StateInfoIndex {
    return new StateInfoIndex().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StateInfoIndex {
    return new StateInfoIndex().fromJsonString(jsonString, options);
  }

  static equals(a: StateInfoIndex | PlainMessage<StateInfoIndex> | undefined, b: StateInfoIndex | PlainMessage<StateInfoIndex> | undefined): boolean {
    return proto3.util.equals(StateInfoIndex, a, b);
  }
}

/**
 * StateInfo defines a rollapps' state.
 *
 * @generated from message dymensionxyz.dymension.rollapp.StateInfo
 */
export class StateInfo extends Message<StateInfo> {
  /**
   * stateInfoIndex defines what rollapp the state belongs to
   * and in which index it can be referenced
   *
   * @generated from field: dymensionxyz.dymension.rollapp.StateInfoIndex stateInfoIndex = 1;
   */
  stateInfoIndex?: StateInfoIndex;

  /**
   * sequencer is the bech32-encoded address of the sequencer sent the update
   *
   * @generated from field: string sequencer = 2;
   */
  sequencer = "";

  /**
   * startHeight is the block height of the first block in the batch
   *
   * @generated from field: uint64 startHeight = 3;
   */
  startHeight = protoInt64.zero;

  /**
   * numBlocks is the number of blocks included in this batch update
   *
   * @generated from field: uint64 numBlocks = 4;
   */
  numBlocks = protoInt64.zero;

  /**
   * DAPath is the description of the location on the DA layer
   *
   * @generated from field: string DAPath = 5;
   */
  DAPath = "";

  /**
   * creationHeight is the height at which the UpdateState took place
   *
   * @generated from field: uint64 creationHeight = 7;
   */
  creationHeight = protoInt64.zero;

  /**
   * status is the status of the state update
   *
   * @generated from field: dymensionxyz.dymension.common.Status status = 8;
   */
  status = Status.PENDING;

  /**
   * BDs is a list of block description objects (one per block)
   * the list must be ordered by height, starting from startHeight to startHeight+numBlocks-1
   *
   * @generated from field: dymensionxyz.dymension.rollapp.BlockDescriptors BDs = 9;
   */
  BDs?: BlockDescriptors;

  /**
   * created_at is the timestamp at which the StateInfo was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * NextProposer is the bech32-encoded address of the proposer that we expect to see in the next state info.
   * Most of the time NextProposer is the current proposer. In case of rotation it is changed to the successor.
   *
   * @generated from field: string nextProposer = 11;
   */
  nextProposer = "";

  constructor(data?: PartialMessage<StateInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.StateInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stateInfoIndex", kind: "message", T: StateInfoIndex },
    { no: 2, name: "sequencer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "startHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "numBlocks", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "DAPath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "creationHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 9, name: "BDs", kind: "message", T: BlockDescriptors },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "nextProposer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StateInfo {
    return new StateInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StateInfo {
    return new StateInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StateInfo {
    return new StateInfo().fromJsonString(jsonString, options);
  }

  static equals(a: StateInfo | PlainMessage<StateInfo> | undefined, b: StateInfo | PlainMessage<StateInfo> | undefined): boolean {
    return proto3.util.equals(StateInfo, a, b);
  }
}

/**
 * StateInfoSummary is a compact representation of StateInfo
 *
 * @generated from message dymensionxyz.dymension.rollapp.StateInfoSummary
 */
export class StateInfoSummary extends Message<StateInfoSummary> {
  /**
   * stateInfoIndex defines what rollapp the state belongs to
   * and in which index it can be referenced
   *
   * @generated from field: dymensionxyz.dymension.rollapp.StateInfoIndex stateInfoIndex = 1;
   */
  stateInfoIndex?: StateInfoIndex;

  /**
   * status is the status of the state update
   *
   * @generated from field: dymensionxyz.dymension.common.Status status = 2;
   */
  status = Status.PENDING;

  /**
   * creationHeight is the height at which the UpdateState took place
   *
   * @generated from field: uint64 creationHeight = 3;
   */
  creationHeight = protoInt64.zero;

  constructor(data?: PartialMessage<StateInfoSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.StateInfoSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stateInfoIndex", kind: "message", T: StateInfoIndex },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 3, name: "creationHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StateInfoSummary {
    return new StateInfoSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StateInfoSummary {
    return new StateInfoSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StateInfoSummary {
    return new StateInfoSummary().fromJsonString(jsonString, options);
  }

  static equals(a: StateInfoSummary | PlainMessage<StateInfoSummary> | undefined, b: StateInfoSummary | PlainMessage<StateInfoSummary> | undefined): boolean {
    return proto3.util.equals(StateInfoSummary, a, b);
  }
}

/**
 * BlockHeightToFinalizationQueue defines a map from block height to list of states to finalized
 *
 * @generated from message dymensionxyz.dymension.rollapp.BlockHeightToFinalizationQueue
 */
export class BlockHeightToFinalizationQueue extends Message<BlockHeightToFinalizationQueue> {
  /**
   * CreationHeight is the block height that the state should be finalized
   *
   * @generated from field: uint64 creationHeight = 1;
   */
  creationHeight = protoInt64.zero;

  /**
   * FinalizationQueue is a list of states that are waiting to be finalized
   * when the block height becomes creationHeight
   *
   * @generated from field: repeated dymensionxyz.dymension.rollapp.StateInfoIndex finalizationQueue = 2;
   */
  finalizationQueue: StateInfoIndex[] = [];

  /**
   * RollappID is the rollapp which the queue belongs to
   *
   * @generated from field: string rollapp_id = 3;
   */
  rollappId = "";

  constructor(data?: PartialMessage<BlockHeightToFinalizationQueue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.BlockHeightToFinalizationQueue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creationHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "finalizationQueue", kind: "message", T: StateInfoIndex, repeated: true },
    { no: 3, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockHeightToFinalizationQueue {
    return new BlockHeightToFinalizationQueue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockHeightToFinalizationQueue {
    return new BlockHeightToFinalizationQueue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockHeightToFinalizationQueue {
    return new BlockHeightToFinalizationQueue().fromJsonString(jsonString, options);
  }

  static equals(a: BlockHeightToFinalizationQueue | PlainMessage<BlockHeightToFinalizationQueue> | undefined, b: BlockHeightToFinalizationQueue | PlainMessage<BlockHeightToFinalizationQueue> | undefined): boolean {
    return proto3.util.equals(BlockHeightToFinalizationQueue, a, b);
  }
}

